<ion-content class="ion-padding">
  <usucampeao-projetos-listar-proximos [projetos]="projetos" [projetosProximos]="projetosProximos"
    (aoBuscarLocalizacao)="carregarProjetosProximos($event)" (aoBuscarTodosOsProjetos)="realizarNovaBuscaDeTodosOsProjetos($event)"
    (aoCarregarNovaPaginaProjetos)="carregarNovaPaginaProjetos($event)" (aoSelecionarProjeto)="irParaDetalhesDoProjeto($event)">
    <p class="ion-no-margin" description>Selecione o bairro aonde está localizado o seu imóvel</p>
  </usucampeao-projetos-listar-proximos>
</ion-content>
